import React, { useEffect, useState } from "react";
import "./ActionPlan.css";
import { useNavigate } from "react-router-dom";
import { db, storage } from "../firebase";
import { collection, addDoc, deleteDoc, doc, query, where, getDocs, getDoc, updateDoc } from "firebase/firestore";
import { getDownloadURL, ref, uploadBytes } from "firebase/storage";

const LeaveApplication = () => {
  const navigate = useNavigate();

  useEffect(() => {
    if (sessionStorage.getItem("login") !== "true") {
      navigate("/")
    }
  }, [])
  const [month, setMonth] = useState("");
  const [year, setYear] = useState("");
  const [leaveRegister, setLeaveRegister] = useState([]);
  const [leaveData, setLeaveData] = useState({
    acl: 0, ael: 0, aml: 0, accl: 0, aodl: 0,
    ucl: 0, uel: 0, uml: 0, uccl: 0, uodl: 0,
    bcl: 0, bel: 0, bml: 0, bccl: 0, bodl: 0,
  });

  const name = localStorage.getItem("empname");
  const empId = localStorage.getItem("empid");


  // Fetch leave data from Firestore
  const fetchLeaveData = async () => {
    try {
      const leaveRef = doc(db, "empmaster", empId, String(document.getElementById("dd3").value), "leave");
      const docSnap = await getDoc(leaveRef);
      if (docSnap.exists()) {
        const data = docSnap.data();
        setLeaveData({
          acl: data.acl || 0, ael: data.ael || 0, aml: data.aml || 0, accl: data.accl || 0, aodl: data.aodl || 0,
          ucl: data.ucl || 0, uel: data.uel || 0, uml: data.uml || 0, uccl: data.uccl || 0, uodl: data.uodl || 0,
          bcl: data.bcl || 0, bel: data.bel || 0, bml: data.bml || 0, bccl: data.bccl || 0, bodl: data.bodl || 0,
        });
      } else {
        console.log("No leave data found.");
      }
    } catch (error) {
      console.error("Error fetching leave data:", error);
    }
  };


  useEffect(() => {
    const fetchLeaveRegister = async () => {
      if (!month || !year) return;
      try {
        console.log("Fetching leave application plans for month:", month);
        const q = query(collection(db, "leaveregister"), where("empid", "==", empId), where("month", "==", String(month + " " + year)));
        const querySnapshot = await getDocs(q);
        if (querySnapshot.empty) {
          console.log("No leave application found for the selected month.");
          setLeaveRegister([]);
          return;
        }
        const actions = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          leavehead: doc.data().leavehead || "",
          prefix: doc.data().prefix || "",
          leavefrom: doc.data().leavefrom || "",
          leaveto: doc.data().leaveto || "",
          sufix: doc.data().sufix || "",
          reason: doc.data().reason || "",
          supportdoc: doc.data().supportdoc || "",
          joiningreport: doc.data().joiningreport || "",
          currentstatus: doc.data().currentstatus || "",
          saved: true,
        }));
        console.log("Fetched leave application:", actions);
        setLeaveRegister(actions);
      } catch (error) {
        console.error("Error fetching leave application:", error);
      }
    };
    fetchLeaveRegister();
  }, [month, year]);

  const handleDeleteAction = async (index) => {
    if (window.confirm("Do you want to delete the leave application?")) {
      if (leaveRegister[index].id) {
        try {
          await deleteDoc(doc(db, "leaveregister", leaveRegister[index].id));
        } catch (error) {
          console.error("Error deleting application:", error);
        }
      }
      const updatedActions = leaveRegister.filter((_, i) => i !== index);
      setLeaveRegister(updatedActions);
    }
  }
  const handleBack = (e) => {
    e.preventDefault();
    navigate(-1)
  }
// 1. Better add row – make sure all fields exist from beginning
const handleAddAction = () => {
  setLeaveRegister(prev => [
    ...prev,
    {
      leavehead: "",
      prefix: "",
      leavefrom: "",
      leaveto: "",
      sufix: "",
      reason: "",
      supportdoc: "",
      joiningreport: "",
      currentstatus: "",
      saved: false,
      id: null
    }
  ]);
};

// 2. Add debug logs in upload handlers (very important!)
const handleFileUpload1 = async (index, file) => {
  if (!file) return;

  try {
    console.log(`Uploading support doc for row ${index}...`);
    const fileRef = ref(storage, `uploads/${empId}/${month}_${year}/support_${Date.now()}_${file.name}`);
    await uploadBytes(fileRef, file);
    const fileURL = await getDownloadURL(fileRef);
    console.log("Upload success! URL:", fileURL);

    setLeaveRegister(prev => {
      const updated = [...prev];
      updated[index] = {
        ...updated[index],
        supportdoc: fileURL
      };
      console.log("Updated state for row", index, "→ supportdoc:", updated[index].supportdoc);
      return updated;
    });
  } catch (error) {
    console.error("Support doc upload failed:", error);
    alert("Failed to upload supporting document");
  }
};



// Same for handleFileUpload2 (add similar logs)
const handleFileUpload2 = async (index, file) => {
  if (!file) return;

  try {
    console.log(`Uploading joining report for row ${index}...`);
    const fileRef = ref(storage, `uploads/${empId}/${month}_${year}/joining_${Date.now()}_${file.name}`);
    await uploadBytes(fileRef, file);
    const fileURL = await getDownloadURL(fileRef);
    console.log("Upload success! URL:", fileURL);

    setLeaveRegister(prev => {
      const updated = [...prev];
      updated[index] = {
        ...updated[index],
        joiningreport: fileURL
      };
      console.log("Updated state for row", index, "→ joiningreport:", updated[index].joiningreport);
      return updated;
    });
  } catch (error) {
    console.error("Joining report upload failed:", error);
    alert("Failed to upload joining report");
  }
};
// 3. Add strong validation + debug before saving
const handleSaveAction = async (index) => {
  const action = leaveRegister[index];

  if (!month || !year) {
    alert("Please select month and year first!");
    return;
  }

  if (!action.leavehead) {
    alert("Please select Leave Head before saving.");
    return;
  }

  console.log("=== About to save to Firestore ===");
  console.log("Document data:", {
    empid: empId,
    month: `${month} ${year}`,
    leavehead: action.leavehead,
    supportdoc: action.supportdoc || "(empty)",
    joiningreport: action.joiningreport || "(empty)",
  });

  try {
    const docRef = await addDoc(collection(db, "leaveregister"), {
      empid: empId,
      month: `${month} ${year}`,
      leavehead: action.leavehead || "",
      prefix: action.prefix || "",
      leavefrom: action.leavefrom || "",
      leaveto: action.leaveto || "",
      sufix: action.sufix || "",
      reason: action.reason || "",
      supportdoc: action.supportdoc || "",
      joiningreport: action.joiningreport || "",
      currentstatus: 'Forwarded to SSH',
      sshremarks: "",
      deeremarks: "",
      leaveapproved: 0,
      kvk: String(localStorage.getItem("kvk") || ""),
      empname: String(localStorage.getItem("empname") || ""),
      empdesig: String(localStorage.getItem("empdesig") || ""),
      createdAt: new Date(), // ← very useful for debugging
    });

    console.log("Document successfully created! ID:", docRef.id);

    setLeaveRegister(prev => {
      const updated = [...prev];
      updated[index] = {
        ...updated[index],
        id: docRef.id,
        saved: true
      };
      return updated;
    });
  } catch (error) {
    console.error("Save failed:", error);
    alert("Failed to save leave application: " + error.message);
  }
};
  return (
    <div className="container">
      <h1 className="welcome">Leave Application of {name || "User"}</h1>
      <center><select className="dropdown" id="dd3" onChange={(e) => fetchLeaveData(e.target.value)} style={{ width: '300px', height: '40px', marginTop: '0px' }}>
        <option value="">Select Calender Year</option>
        {["2025", "2026", "2027", "2028"].map((m) => (
          <option key={m} value={m}>{m}</option>
        ))}
      </select>
      </center>
      {/* Leave Account Table */}
      <table className="budget-table">
        <thead>
          <tr>
            <th>Leave Account</th>
            <th>Casual Leave</th>
            <th>Earned Leave</th>
            <th>Medical Leave</th>
            <th>Chield Care Leave</th>
            <th>On Duty Leave</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Allocation</td>
            <td>{leaveData.acl}</td>
            <td>{leaveData.ael}</td>
            <td>{leaveData.aml}</td>
            <td>{leaveData.accl}</td>
            <td>{leaveData.aodl}</td>
          </tr>
          <tr>
            <td>Utilized</td>
            <td>{leaveData.ucl}</td>
            <td>{leaveData.uel}</td>
            <td>{leaveData.uml}</td>
            <td>{leaveData.uccl}</td>
            <td>{leaveData.uodl}</td>
          </tr>
          <tr>
            <td>Balance</td>
            <td>{leaveData.acl - leaveData.ucl}</td>
            <td>{leaveData.ael - leaveData.uel}</td>
            <td>{leaveData.aml - leaveData.uml}</td>
            <td>{leaveData.accl - leaveData.uccl}</td>
            <td>{leaveData.aodl - leaveData.uodl}</td>
          </tr>
        </tbody>
      </table>
      <div style={{ display: 'flex', flexDirection: 'row' }}>
        <div style={{ display: 'flex', flexDirection: 'column' }}>
          <label className="label">Select Month and Year:</label>
          <select className="dropdown" id="dd1" value={month} onChange={(e) => setMonth(e.target.value)}>
            <option value="">Month</option>
            {["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"].map((m) => (
              <option key={m} value={m}>{m}</option>
            ))}
          </select>
        </div>
        &nbsp;
        <select className="dropdown" id="dd2" value={year} onChange={(e) => setYear(e.target.value)} style={{ width: '150px', height: '40px', marginTop: '33px' }}>
          <option value="">Year</option>
          {["2025", "2026", "2027", "2028"].map((m) => (
            <option key={m} value={m}>{m}</option>
          ))}
        </select>
      </div>

      {month && (
        <div className="action-section">
          <table className="action-table">
            <thead>
              <tr>
                <th style={{ width: '120px' }}>Leave Head</th>
                <th style={{ width: '150px' }}>Leave Prefix</th>
                <th>From</th>
                <th>To</th>
                <th style={{ width: '150px' }}>Leave Suffix</th>
                <th style={{ width: '150px' }}>Leave Reason</th>
                <th style={{ width: '150px' }}>Supporting Documnet</th>
                <th style={{ width: '120px' }}>Action</th>
                <th style={{ width: '120px' }}>Current Status</th>
                <th style={{ width: '120px' }}>Upload Joining Report</th>
              </tr>
            </thead>
            <tbody>
  {leaveRegister.map((action, index) => (
    <tr key={index}>
      <td>
        <select
          style={{ height: '38px', backgroundColor: 'white' }}
          value={action.leavehead}
          onChange={(e) => {
            const updatedActions = [...leaveRegister];
            updatedActions[index].leavehead = e.target.value;
            setLeaveRegister(updatedActions);
          }}
          disabled={action.saved}
        >
          <option value="">Select</option>
          <option value="Casual Leave">Casual Leave</option>
          <option value="Earned Leave">Earned Leave</option>
          <option value="Medical Leave">Medical Leave</option>
          <option value="Chield Care Leave">Chield Care Leave</option>
          <option value="On Duty Leave">On Duty Leave</option>
        </select>
      </td>

      <td>
        <input
          type="text"
          value={action.prefix}
          onChange={(e) => {
            const updatedActions = [...leaveRegister];
            updatedActions[index].prefix = e.target.value;
            setLeaveRegister(updatedActions);
          }}
          className="input-box"
          disabled={action.saved}
        />
      </td>

      <td>
        {action.saved ? (
          action.leavefrom
            ? new Date(action.leavefrom).toLocaleDateString('en-GB').replace(/\//g, '-')
            : '-'
        ) : (
          <input
            type="date"
            value={action.leavefrom ?? ''}
            onChange={(e) => {
              const updatedActions = [...leaveRegister];
              updatedActions[index].leavefrom = e.target.value;
              setLeaveRegister(updatedActions);
            }}
            className="input-box"
            disabled={action.saved}
          />
        )}
      </td>

      <td>
        {action.saved ? (
          action.leaveto
            ? new Date(action.leaveto).toLocaleDateString('en-GB').replace(/\//g, '-')
            : '-'
        ) : (
          <input
            type="date"
            value={action.leaveto ?? ''}
            min={action.leavefrom || undefined}
            onChange={(e) => {
              const updatedActions = [...leaveRegister];
              updatedActions[index].leaveto = e.target.value;
              setLeaveRegister(updatedActions);
            }}
            className="input-box"
            disabled={action.saved}
          />
        )}
      </td>

      <td>
        <input
          type="text"
          value={action.sufix}
          onChange={(e) => {
            const updatedActions = [...leaveRegister];
            updatedActions[index].sufix = e.target.value;
            setLeaveRegister(updatedActions);
          }}
          className="input-box"
          disabled={action.saved}
        />
      </td>

      <td>
        <input
          type="text"
          value={action.reason}
          onChange={(e) => {
            const updatedActions = [...leaveRegister];
            updatedActions[index].reason = e.target.value;
            setLeaveRegister(updatedActions);
          }}
          className="input-box"
          disabled={action.saved}
        />
      </td>

      {/* Supporting Document */}
      <td>
        <input
          type="file"
          accept=".pdf,.doc,.docx"
          style={{ width: "100px" }}
          onChange={(e) => handleFileUpload1(index, e.target.files[0])}
          disabled={action.saved && !!action.supportdoc}
        />
        <br />
        {action.supportdoc && (
          <a
            href={action.supportdoc}
            target="_blank"
            rel="noopener noreferrer"
            style={{ fontSize: '0.85em' }}
          >
            View Document
          </a>
        )}
      </td>

      <td>
        <button
          className={action.saved ? "delete-btn" : "save-btn"}
          onClick={() => (action.saved ? handleDeleteAction(index) : handleSaveAction(index))}
        >
          {action.saved ? "Delete" : "Save"}
        </button>
      </td>

      <td>
        <p>{action.currentstatus}</p>
      </td>

      {/* Joining Report */}
      <td>
        <input
          type="file"
          accept=".pdf,.doc,.docx"
          style={{ width: "100px" }}
          onChange={(e) => handleFileUpload2(index, e.target.files[0])}
          disabled={action.saved && !!action.joiningreport}
        />
        <br />
        {action.joiningreport && (
          <a
            href={action.joiningreport}
            target="_blank"
            rel="noopener noreferrer"
            style={{ fontSize: '0.85em' }}
          >
            View Joining Report
          </a>
        )}
      </td>
    </tr>
  ))}
</tbody>          </table>
          <button className="add-btn" onClick={handleAddAction}>Add Row</button>
        </div>
      )}
      <img src="/assets/back.png" style={{ width: '100px' }} onClick={handleBack} alt="" />

    </div>
  );
};

export default LeaveApplication;
